// extracted by mini-css-extract-plugin
module.exports = {"base":"ArtistsContainer_base__5N82G"};